import React, { FC } from 'react'

import styles from './paymentFailedBanner.module.scss'

/**
 * Shown when the account has a card on file but a payment failed (subscription
 * status past_due / unpaid). Non-dismissible — it clears once billing is fixed
 * and the subscription recovers. Does NOT suppress the data-processing banner.
 */
export const PaymentFailedBanner: FC = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <svg
            fill="none"
            height="20"
            viewBox="0 0 20 20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" fill="#DC2626" r="10" />
            <path
              d="M10 6V10"
              stroke="white"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <circle cx="10" cy="13.5" fill="white" r="1" />
          </svg>
        </div>
        <div className={styles.textContent}>
          <div className={styles.title}>Payment Failed</div>
          <div className={styles.message}>
            We couldn&apos;t process your payment. Please update your billing
            details to avoid service interruption.
          </div>
        </div>
      </div>
    </div>
  )
}
